(() => {
  const desktopHover = window.matchMedia('(min-width: 1001px) and (hover: hover) and (pointer: fine)');
  const init = () => {
    const menus = [...document.querySelectorAll('[data-ps-nav-menu]')];
    menus.forEach(menu => {
      if (menu.dataset.navReady) return;
      menu.dataset.navReady = 'true';
      menu.addEventListener('toggle', () => {
        if (!menu.open) return;
        menus.forEach(other => {
          if (other !== menu && !other.contains(menu) && !menu.contains(other)) other.open = false;
        });
        menu.querySelector('input[type="search"]')?.focus();
      });
      menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        menu.open = false;
        menu.querySelector('summary')?.focus();
      });
      if (!menu.closest('.ps-desktop-nav')) return;
      const summary = menu.querySelector('summary');
      const hoverTarget = menu.closest('.ps-nav-accessories') || menu;
      let closeTimer;
      const cancelClose = () => window.clearTimeout(closeTimer);
      hoverTarget.addEventListener('mouseenter', () => {
        if (!desktopHover.matches) return;
        cancelClose();
        menu.open = true;
      });
      hoverTarget.addEventListener('mouseleave', () => {
        if (!desktopHover.matches) return;
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (!hoverTarget.matches(':hover') && (!menu.matches(':focus-within') || document.activeElement === summary)) menu.open = false;
        }, 180);
      });
      summary.addEventListener('click', event => {
        if (event.detail > 0 && desktopHover.matches && hoverTarget.matches(':hover') && menu.open) event.preventDefault();
      });
      menu.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (desktopHover.matches && !menu.matches(':focus-within') && !hoverTarget.matches(':hover')) menu.open = false;
        }, 0);
      });
      desktopHover.addEventListener('change', () => {
        cancelClose();
        menu.open = false;
      });
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-ps-nav-menu][open]').forEach(menu => {
      if (!menu.contains(event.target) && !(desktopHover.matches && menu.closest('.ps-desktop-nav') && (menu.closest('.ps-nav-accessories') || menu).matches(':hover'))) menu.open = false;
    });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();

// Keep the custom header in sync with Horizon's asynchronous basket updates.
(() => {
  const renderCount = count => {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('.ps-bag').forEach(link => {
      const badge = link.querySelector('.ps-bag-count');
      if (badge) badge.textContent = String(count);
      const label = link.querySelector('.ps-bag-label')?.textContent.trim();
      if (label) link.setAttribute('aria-label', `${label} (${count})`);
    });
  };
  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, event => {
      event.promise?.then(({ cart, detail }) => {
        renderCount(cart?.totalQuantity ?? detail?.itemCount);
      }).catch(() => {});
    });
  }).catch(() => {});
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart.js`, { credentials: 'same-origin' })
      .then(response => response.ok ? response.json() : null)
      .then(cart => { if (cart) renderCount(cart.item_count); })
      .catch(() => {});
  });
})();

(() => {
  const paths = {
    '→': 'M4 12h16m-6-6 6 6-6 6',
    '←': 'M20 12H4m6-6-6 6 6 6',
    '↓': 'M12 4v16m-6-6 6 6 6-6',
    '↑': 'M12 20V4m-6 6 6-6 6 6',
    '↗': 'M6 18 18 6M6 6h12v12',
    '↘': 'M6 6 18 18M6 18h12V6',
    '↖': 'M18 18 6 6M6 18V6h12',
    '↙': 'M18 6 6 18M6 6v12h12',
    '›': 'm9 5 7 7-7 7',
    '‹': 'm15 5-7 7 7 7',
    '▾': 'm5 9 7 7 7-7',
    '⌄': 'm5 9 7 7 7-7',
    '➜': 'M4 12h16m-6-6 6 6-6 6',
    '➔': 'M4 12h16m-6-6 6 6-6 6'
  };
  const glyphs = /[→←↓↑↗↘↖↙›‹▾⌄➜➔]/;
  const observedRoots = new WeakSet();
  const makeIcon = glyph => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    for (const [name, value] of Object.entries({viewBox:'0 0 24 24',width:'20',height:'20',fill:'none',stroke:'currentColor','stroke-width':'2','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'})) svg.setAttribute(name, value);
    svg.setAttribute('class', 'ps-icon ps-arrow');
    svg.style.cssText = 'display:inline-block;vertical-align:middle;width:20px;height:20px;min-width:20px;max-width:none;flex:0 0 20px;overflow:visible;fill:none;stroke:currentColor';
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', paths[glyph]);
    svg.append(path);
    return svg;
  };
  const replaceText = node => {
    const parent = node.parentElement;
    if (!parent || !glyphs.test(node.nodeValue) || parent.closest('svg,script,style,input,textarea,option,select,[contenteditable="true"]')) return;
    if (!parent.closest('a,button,summary,[aria-hidden="true"]')) return;
    const fragment = document.createDocumentFragment();
    for (const part of node.nodeValue.split(/([→←↓↑↗↘↖↙›‹▾⌄➜➔])/)) fragment.append(paths[part] ? makeIcon(part) : document.createTextNode(part));
    node.replaceWith(fragment);
  };
  const scan = root => {
    if (root.nodeType === Node.TEXT_NODE) { replaceText(root); return; }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceText);
    root.querySelectorAll?.('platespec-configurator').forEach(host => { if (host.shadowRoot) observe(host.shadowRoot); });
  };
  const observe = root => {
    if (observedRoots.has(root)) return;
    observedRoots.add(root);
    scan(root);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') replaceText(record.target);
        else record.addedNodes.forEach(scan);
      }
    }).observe(root, {childList:true,subtree:true,characterData:true});
  };
  observe(document.body);
  customElements.whenDefined('platespec-configurator').then(() => {
    document.querySelectorAll('platespec-configurator').forEach(host => { if (host.shadowRoot) observe(host.shadowRoot); });
  });
})();
